import React from "react";

const CommentView = ({ message, _style, children }) => {
  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#FAFAFA",
      }}
    >
      <div
        data-view="comment-view"
        style={{
          height: 100,
          width: 411,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "1px solid #4D4D4D",
          borderRadius: 10,
          backgroundColor: "rgba(255,255,255,0.95)",
          color: "#4D4D4D",
          fontFamily: "Proxima Nova",
          fontSize: 16,
          fontWeight: "bold",
          lineHeight: "19px",
          ..._style,
        }}
      >
        {children ||
          message ||
          `There are no orders in your queue. Check back later!`}
      </div>
    </div>
  );
};

export default CommentView;
